import { MetaT } from '@global/types';

export default {
    title: 'Агрегатор служб доставки — Быстрая и удобная отправка грузов | LiveCargo',
    description:
        'LiveCargo — это удобный агрегатор служб доставки. Сравните тарифы и условия лучших транспортных компаний, найдите оптимальный вариант доставки для вашего бизнеса или личных нужд.',
    keywords:
        'агрегатор служб доставки, сравнение доставок, сервис доставки, найти доставку, доставка грузов, транспортные компании, логистика, доставка посылок, livecargo',
} as MetaT;
